import {
	CalendarOutlined,
	ClockCircleOutlined,
	EditOutlined,
	ExclamationCircleOutlined,
	HomeOutlined,
	LoginOutlined,
	LogoutOutlined,
	SettingOutlined,
	TeamOutlined,
	UserOutlined,
	WarningOutlined,
} from "@ant-design/icons";
import React from "react";

export const routes = {
	home: {
		key: "home",
		slug: "home",
		to: "/home",
		title: "Inicio",
		icon: <HomeOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
	},

	checkin: {
		key: "checkin",
		slug: "checkin",
		to: "/checkin",
		title: "Fichar",
		icon: <ClockCircleOutlined />,
		showInMenu: true,
		showHeader: false,
		showSearch: false,
		action: null,
	},

	rrhh: {
		key: "rrhh",
		slug: "rrhh",
		to: "/rrhh",
		title: "RRHH",
		icon: <UserOutlined />,
		showInMenu: true,
		showHeader: false,
		showSearch: false,
		action: null,
		children: {
			attendancerecords: {
				key: "attendancerecords",
				slug: "attendancerecords",
				to: "/attendancerecords",
				title: "Fichajes",
				icon: <ClockCircleOutlined />,
				showInMenu: true,
				showHeader: true,
				showSearch: true,
				action: null,
			},

			timechangerequests: {
				key: "timechangerequests",
				slug: "timechangerequests",
				to: "/timechangerequests",
				title: "Solicitudes",
				icon: <EditOutlined />,
				showInMenu: true,
				showHeader: true,
				showSearch: true,
				action: null,
			},

			calendarpermissions: {
				key: "calendarpermissions",
				slug: "calendarpermissions",
				to: "/calendarpermissions",
				title: "Permisos",
				icon: <CalendarOutlined />,
				showInMenu: true,
				showHeader: true,
				showSearch: true,
				action: null,
			},

			irregularitys: {
				key: "irregularitys",
				slug: "irregularitys",
				to: "/irregularitys",
				title: "Irregularidades",
				icon: <ExclamationCircleOutlined />,
				showInMenu: true,
				showHeader: true,
				showSearch: true,
				action: null,
			},
			appointments: {
				key: "appointments",
				slug: "appointments",
				to: "/appointments",
				title: "Turnos",
				icon: <CalendarOutlined />,
				showInMenu: true,
				showHeader: true,
				showSearch: true,
				action: null,
			},
		},
	},

	profile: {
		key: "profile",
		slug: "profile",
		to: "/profile",
		title: "Perfil",
		icon: <UserOutlined />,
		showInMenu: false,
		showHeader: true,
		showSearch: true,
		action: null,
	},

	/*
	gmao: {
		key: "gmao",
		slug: "gmao",
		to: "/gmao",
		title: "GMAO",
		icon: <ToolOutlined />,
		showInMenu: true,
		showHeader: false,
		showSearch: false,
		action: null,
		children: {
			workorders: {
				key: "workorders",
				slug: "workorders",
				to: "/workorders",
				title: "Partes de trabajo",
				icon: <FileTextOutlined />,
				showInMenu: true,
				showHeader: true,
				showSearch: true,
				action: null,
			},

			incidents: {
				key: "incidents",
				slug: "incidents",
				to: "/incidents",
				title: "Incidencias",
				icon: <WarningOutlined />,
				showInMenu: true,
				showHeader: true,
				showSearch: true,
				action: null,
			},

			calendarincidents: {
				key: "calendarincidents",
				slug: "calendarincidents",
				to: "/calendarincidents",
				title: "Incidencias",
				icon: <CalendarOutlined />,
				showInMenu: true,
				showHeader: true,
				showSearch: true,
				action: null,
			},
			calendarmaintenances: {
				key: "calendarmaintenances",
				slug: "calendarmaintenances",
				to: "/calendarmaintenances",
				title: "Mantenimientos",
				icon: <CalendarOutlined />,
				showInMenu: true,
				showHeader: true,
				showSearch: true,
				action: null,
			},

			equipments: {
				key: "equipments",
				slug: "equipments",
				to: "/equipments",
				title: "Equipos",
				icon: <ToolOutlined />,
				showInMenu: true,
				showHeader: true,
				showSearch: true,
				action: null,
			},

			maintenances: {
				key: "maintenances",
				slug: "maintenances",
				to: "/maintenances",
				title: "Mantenimientos",
				icon: <ToolOutlined />,
				showInMenu: true,
				showHeader: true,
				showSearch: true,
				action: null,
			},
		},

	},
	*/

	maestros: {
		key: "maestros",
		slug: "maestros",
		to: "/maestros",
		title: "Maestros",
		icon: <SettingOutlined />,
		showInMenu: true,
		showHeader: false,
		showSearch: false,
		action: null,
		children: {
			/*
			locations: {
				key: "locations",
				slug: "locations",
				to: "/locations",
				title: "Ubicaciones",
				icon: <EnvironmentOutlined />,
				showInMenu: true,
				showHeader: true,
				showSearch: true,
				action: null,
			},
			*/

			users: {
				key: "users",
				slug: "users",
				to: "/users",
				title: "Usuarios",
				icon: <UserOutlined />,
				showInMenu: true,
				showHeader: true,
				showSearch: true,
				action: null,
			},

			roles: {
				key: "roles",
				slug: "roles",
				to: "/roles",
				title: "Roles",
				icon: <TeamOutlined />,
				showInMenu: true,
				showHeader: true,
				showSearch: true,
				action: null,
			},

			shifttypes: {
				key: "shifttypes",
				slug: "shifttypes",
				to: "/shifttypes",
				title: "Tipos de turno",
				icon: <CalendarOutlined />,
				showInMenu: true,
				showHeader: true,
				showSearch: true,
				action: null,
			},

			groups: {
				key: "groups",
				slug: "groups",
				to: "/groups",
				title: "Grupos",
				icon: <TeamOutlined />,
				showInMenu: true,
				showHeader: true,
				showSearch: true,
				action: null,
			},

			holidays: {
				key: "holidays",
				slug: "holidays",
				to: "/holidays",
				title: "Festivos",
				icon: <CalendarOutlined />,
				showInMenu: true,
				showHeader: true,
				showSearch: true,
				action: null,
			},

			irregularitytypes: {
				key: "irregularitytypes",
				slug: "irregularitytypes",
				to: "/irregularitytypes",
				title: "Tipos de irregularidades",
				icon: <WarningOutlined />,
				showInMenu: true,
				showHeader: true,
				showSearch: true,
				action: null,
			},
		},
	},

	login: {
		key: "login",
		slug: "login",
		to: "/login",
		title: "LOGIN",
		icon: <LoginOutlined />,
		showInMenu: false,
		showHeader: false,
		showSearch: false,
		action: null,
	},
	logout: {
		key: "logout",
		slug: "logout",
		to: "/logout",
		title: "Log out",
		icon: <LogoutOutlined />,
		showInMenu: false,
		showHeader: false,
		showSearch: false,
		action: null,
	},
};
